import {css} from "lit";

export default css`
  .hidden {
    display: none;
  }

  .cursor-default {
    cursor: default;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .opacity-70 {
    opacity: 0.7;
  }

  .border-opacity-70 {
    border: 1px solid rgb(217, 217, 217, 0.7);
  }
`;